import React from 'react';
import styles from './ToolbarLayout.module.scss';

const ToolbarLayout = (props) => {
    const { className = '', children } = props;

    return <div className={[className, styles.ToolbarLayout].join(' ')}>{children}</div>;
};

export default ToolbarLayout;
